import { baseApi } from "../api";

export const metadataAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		postMetadata: builder.mutation({
			query: (arg) => ({
				url: `/rest/user/tracker/metadataValue?key=${arg.key}&value=${arg.value}`,
				method: "POST"
			})
		}),
		deleteMetadata: builder.mutation({
			query: (arg) => ({
				url: `/rest/debug/user/tracker/clear-metadata-value?key=${arg.key}`,
				method: "POST"
			})
		})
	})
});

export const { usePostMetadataMutation, useDeleteMetadataMutation } =
	metadataAPI;
